interface SectionHeaderProps {
  title: string;
  subtitle: string;
  children?: React.ReactNode;
  sortType?: "newest" | "popular" | "on_sale" | "featured";
}

const SectionHeader = ({ title, subtitle, children }: SectionHeaderProps) => {
  return (
    <div className="flex justify-between items-center mb-8 pb-4 border-b border-neutral-800">
      <div className="text-start">
        <h2 className="text-3xl font-bold text-white mb-2">{title}</h2>
        <p className="text-neutral-400 text-base">{subtitle}</p>
      </div>
      <div className="flex items-center">{children}</div>
    </div>
  );
};

export default SectionHeader;
